module.exports = __webpack_public_path__ + "static/media/ic-state-success.61dce081.svg";